<div class="portfolio-box fees">
  <h2 class="ui-headline">{{ 'new_strategy.portfolio_screen.graph_box.costs.title' | translate }}</h2>
  <p>
    {{ 'new_strategy.portfolio_screen.graph_box.costs.p' | translate }}
  </p>

  <ng-container *ngIf="showFeesNotice">
    <app-ui-info-box status="info">
      <p [innerHTML]="'ACCOUNT.fees.notice' | translate"></p>
    </app-ui-info-box>
  </ng-container>

  <div class="fees-number">
    <div>
      <p>
        {{ 'new_strategy.portfolio_screen.graph_box.costs.annual' | translate }}
      </p>
      <p class="big">
        {{ currentAccount?.inyova_fee | translatePercent: customer?.language }}
        <app-ui-tooltip color="yellow" size="small" *ngIf="!customer?.inyova_pro" (mouseenter)="trackTooltip('annualInfo')">
          <span>
            {{ 'new_strategy.portfolio_screen.graph_box.costs.annualInfo' | translate }}
            <a
              [href]="'new_strategy.portfolio_screen.graph_box.costs.readMoreLink' | translate"
              (click)="trackActivity('[Link] Annual fee schedule read more')"
              target="_blank"
            >
              <b>{{ 'new_strategy.portfolio_screen.graph_box.costs.readMore' | translate }}</b>
            </a>
          </span>
        </app-ui-tooltip>
      </p>
    </div>
    <div>
      <p>{{ 'new_strategy.portfolio_screen.graph_box.costs.monthly' | translate }}</p>
      <p class="big">
        {{ monthlyFee.value | translateNumber: customer?.language : currentAccount?.currency : monthlyFee.decimal }}
        <app-ui-tooltip
          size="small"
          color="yellow"
          [content]="'new_strategy.portfolio_screen.graph_box.costs.monthlyInfo' | translate"
          (mouseenter)="trackTooltip('monthly')"
        ></app-ui-tooltip>
      </p>
    </div>
  </div>
  <div class="fees-covering">
    <p>{{ 'new_strategy.portfolio_screen.graph_box.costs.note2' | translate }}</p>
    <div class="fees-icons wrap">
      <div class="fees-icons-icon" *ngFor="let icon of iconArray; let i = index">
        <img [src]="'/assets/images/' + icon + '.svg'" />
        <p [innerHtml]="'new_strategy.portfolio_screen.graph_box.costs.cover' + (i + 1) | translate"></p>
      </div>
    </div>
  </div>
  <a class="show-more" (click)="toggleShowMore()">{{ (showMore ? 'strategy.show_less' : 'strategy.show_more') | translate }}</a>
  <div class="fees-items" *ngIf="showMore">
    <h4
      class="ui-headline"
      [innerHTML]="
        'new_strategy.portfolio_screen.graph_box.costs.moreTitle'
          | translate
            : {
                feepercentage: currentAccount?.inyova_fee | translatePercent: customer?.language
              }
      "
    ></h4>
    <div *ngFor="let item of investmentDetails" class="fees-items-item">
      <p *ngIf="item.fees !== 0">{{ item.title | translate }}</p>
      <p>
        <span *ngIf="item.fees !== 0">
          {{ item.fees | translateNumber: customer?.language : currentAccount?.currency }}
        </span>
      </p>
    </div>
    <p *ngIf="customer?.total_current_amount" class="fees-items-item">
      <span>
        {{ 'new_strategy.portfolio_screen.graph_box.costs.moreOther' | translate }}
        <app-ui-tooltip
          size="small"
          color="yellow"
          [content]="'new_strategy.portfolio_screen.graph_box.costs.moreOtherTooltip' | translate"
          (mouseenter)="trackTooltip('moreOther')"
        ></app-ui-tooltip>
      </span>
      <span>
        {{ customer?.total_current_amount | translateNumber: customer?.language : currentAccount?.currency }}
      </span>
    </p>
    <p class="fees-items-item">
      {{ 'new_strategy.portfolio_screen.graph_box.costs.morePerformance' | translate }}
    </p>
  </div>
</div>
